import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

function Component(props){
    const navigate = useNavigate();
    return(
        <div style={{
            width:'100%',
            backgroundColor:'#333',
            padding:'0px 5vw',
            color:'white',
            boxSizing: 'border-box',
            display:'flex',
            flexDirection:'row',
            justifyContent:'space-between',
            alignItems:'center',
            position:'sticky',
            top:0,
            minHeight:'50px'
        }}>
            <div style={{cursor:'pointer'}} onClick={()=>{navigate('/')}}>Icon</div>
            <div>{props.token.token}</div>
            <div>{props.token.username}</div>
        </div>
    )
}

export default connect((store)=>{
    return{
      token:store.tokenReducer,
      control:store.controlReducer,
    }
  })(Component)
  